import { render, staticRenderFns } from "./LogsOverview.vue?vue&type=template&id=0fa87f1c"
import script from "./LogsOverview.vue?vue&type=script&lang=js"
export * from "./LogsOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports